'use client'

import { useEffect, useState } from 'react'
import { ArrowRight } from 'lucide-react'

import { Button } from '@/components/ui/button'

import { talentPoolCopy } from '@/app/talent-pool/copy'

type TalentPoolLandingStickyCtaProps = {
  onScrollToUpload: () => void
}

export function TalentPoolLandingStickyCta({
  onScrollToUpload,
}: TalentPoolLandingStickyCtaProps) {
  const copy = talentPoolCopy
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling 80% of viewport height (past hero)
      const scrolled = window.scrollY
      const viewportHeight = window.innerHeight
      setIsVisible(scrolled > viewportHeight * 0.8)
    }

    handleScroll() // Check initial position
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  if (!isVisible) return null

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-border-primary bg-white/95 dark:bg-card/95 px-4 py-3 pb-[calc(env(safe-area-inset-bottom)+0.75rem)] backdrop-blur lg:hidden">
      <div className="mx-auto w-full max-w-6xl">
        <Button
          type="button"
          onClick={onScrollToUpload}
          className="h-12 w-full rounded-xl bg-brand-primary px-3 text-[14px] font-semibold text-white shadow-button hover:bg-brand-primary-hover"
        >
          <span className="min-w-0 truncate">{copy.landing.finalCtaButton}</span>
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
